import { render, staticRenderFns } from "./mingjue.vue?vue&type=template&id=955f6136&scoped=true&"
import script from "./mingjue.vue?vue&type=script&lang=js&"
export * from "./mingjue.vue?vue&type=script&lang=js&"
import style0 from "./mingjue.vue?vue&type=style&index=0&id=955f6136&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955f6136",
  null
  
)

export default component.exports